import React, { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Tools from './components/Tools';
import Contributions from './components/Contributions';
import Education from './components/Education';
import Contact from './components/Contact';
import LanguageToggle from './components/LanguageToggle';
import SectionNav from './components/SectionNav';
import AIChatBot from './components/AIChatBot';
import translations from './translations';
import './styles/colors.css';
import './App.css';

function App() {
  const [language, setLanguage] = useState('en');

  // Get translations for current language
  const t = translations[language];

  // Smooth scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Offset for fixed header if any
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Add smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="App">
      {/* Language Toggle */}
      <LanguageToggle language={language} setLanguage={setLanguage} />

      {/* Section shortcuts (top-left, mirrors the language toggle) */}
      <SectionNav t={t} scrollToSection={scrollToSection} />

      {/* Hero Section */}
      <Hero t={t} scrollToSection={scrollToSection} />

      {/* About Section */}
      <About t={t} language={language} />

      {/* Skills Section */}
      <Skills t={t} />

      {/* Open-Source Tools Section */}
      <Tools t={t} language={language} />

      {/* Projects Section */}
      <Projects t={t} language={language} />

      {/* Open-Source Contributions Section (renders nothing while the list is empty) */}
      <Contributions t={t} language={language} />

      {/* Education Section */}
      <Education t={t} />

      {/* Contact Section */}
      <Contact t={t} />

      {/* AI ChatBot */}
      <AIChatBot />
    </div>
  );
}

export default App;
